import { NgModule } from '@angular/core';
import { FormatTimePipe } from './format-time/format-time.pipe';
import { GenderPrefixPipe } from './gender-prefix/gender-prefix.pipe';
import { FormatDatePipe } from './format-date/format-date.pipe';
import { FormatDecimalsPipe } from './format-decimals/format-decimals.pipe';
import { GenderPipe } from './gender/gender.pipe';
import { ZeroPricePipe } from './zero-price.pipe';

@NgModule({
  declarations: [FormatTimePipe, FormatDatePipe, GenderPrefixPipe, GenderPipe, FormatDecimalsPipe, ZeroPricePipe],
  exports: [FormatTimePipe, FormatDatePipe, GenderPrefixPipe, GenderPipe, FormatDecimalsPipe, ZeroPricePipe],
})
export class PipesModule {}
